import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const ReportsContext = React.createContext(null);

const { Provider } = ReportsContext;
export const ReportsProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        addedReport: null
    });

    const addNewReportAsync = async (data) => {
        try {            
            const addReportApi = await fetchAuthorized(ApiRoutes.Report.AddNewReportLink(),
            {                    
                method: HttpMethods.POST,
                body: JSON.stringify(data),
                collectErrorDetails: true
            }); 
    
            const addedReport = await addReportApi.json();
            setState({ addedReport });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    const deleteReportAsync = async (data) => {
        try {            
            await fetchAuthorized(ApiRoutes.Report.DeleteReportLink({ reportLinkId: data }),
            {                    
                method: HttpMethods.DELETE
            });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            state,
            addNewReportAsync,
            deleteReportAsync
        }}>
            {props.children}
        </Provider>
    );
}